// const development =
//   process.env.NODE_ENV === "development"

//     //UAT
//     // ? "https://omnycomm.com:8012"
//     // : "https://omnycomm.com:8012";

//qa
// ? "https://13.232.143.29:8028"
// : "https://13.232.143.29:8028";

// //prod
// // ? "https://omnycomm.com:8004"
// // : "https://omnycomm.com:8004";

const developmentOmnyComm =
  //QA
  // "https://15.207.21.107:8093/inaam";
  // "http://35.154.30.249:8093/inaam";
  // "http://15.207.21.107:8093/inaam";
  // "https://35.154.30.249:8093/inaam";
  // "https://stagingapi.banatalnujoom.com/reward";
  "https://api.banatalnujoom.com/reward"

    
  //localhost
  // "http://127.0.0.1:8000/inaam";
  
  // Mock Server
  // "https://8f8f4d0a-17c0-4e92-bcc9-f0571ca4727f.mock.pstmn.io/inaam"
  
//PROD
// "https://api.banatalnujoom.com/reward"

export default function isDev(isDealsHub) {
  return developmentOmnyComm;
}

// orders
// orders details
// customers
